import MSection from './index.vue';

MSection.install = app => {
  app.component(MSection.name, MSection);
};

export default MSection;
